import "./AboutUs.css";

function AboutUs() {
  return (
    <div className="page-container">
      <h1>About Us</h1>
      <p>We help people improve their inner peace and clarity.</p>
    </div>
  );
}

export default AboutUs;
